<template>
  <v-container class="pb-0">
    <v-row>
      <v-col>
        <v-container py-0>
          <v-row justify="end">
            <v-btn
              color="primary"
              @click="onAddCompsClick"
              :disabled="$store.getters.hasAccessTo('suppliers:view_only')"
            >
              <v-icon left>mdi-plus-circle</v-icon>Add Comps
            </v-btn>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-data-table
            :items="items"
            :headers="headers"
            :loading="$apollo.loading"
          >
            <template v-slot:item.actions="{ item }">
              <default-list-actions
                :item="item"
                hide-view
                @deleteItem="onDeleteItem"
                @editItem="onEditItem"
                :hide-edit="$store.getters.hasAccessTo('suppliers:view_only')"
                :hide-remove="$store.getters.hasAccessTo('suppliers:view_only')"
              ></default-list-actions>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <supplier-comp-dialog
      :show="showCompDialog"
      @close="showCompDialog = false"
      v-model="selectedComp"
      :supplier-type="supplierType"
      @save="onSaveSupplierComp"
      :services="services"
    ></supplier-comp-dialog>
    <code v-if="debug"> {{ id }} - {{ supplierComps }} </code>
  </v-container>
</template>
<script>
import gql from "graphql-tag";
const SUPPLIER_COMPS = gql`
  query supplierComps($id: ID!) {
    supplierComps(id: $id) {
      edges {
        node {
          id
          paxFrom
          paxTo
          free
          pass
          serviceType
          serviceId
          service {
            id
            name
          }
        }
      }
    }
  }
`;
const UPDATE_SUPPLIER_COMP = gql`
  mutation updateSupplierComp($input: SupplierCompInput!) {
    updateSupplierComp(input: $input) {
      id
      paxFrom
      paxTo
      free
      pass
      serviceId
    }
  }
`;
const CREATE_SUPPLIER_COMP = gql`
  mutation createSupplierComp($input: SupplierCompInput!) {
    createSupplierComp(input: $input) {
      id
      paxFrom
      paxTo
      free
      pass
      serviceId
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteSupplierComp($id: ID!) {
    deleteSupplierComp(id: $id) {
      id
    }
  }
`;
import SupplierCompDialog from "./SupplierCompDialog";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
export default {
  name: "supplier-comps",

  props: {
    supplierId: {
      type: String,
      default: () => "",
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    services: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    SupplierCompDialog,
    DefaultListActions,
  },

  data() {
    return {
      debug: false,
      id: this.supplierId != "" ? this.supplierId : "",
      selectedComp: {
        paxFrom: 1,
        paxTo: 10,
      },
      showCompDialog: false,
      headers: [
        {
          text: "Pax From",
          value: "paxFrom",
          name: "paxFrom",
        },
        {
          text: "Pax To",
          value: "paxTo",
          name: "paxTo",
        },
        {
          text: "Free",
          value: "free",
          name: "free",
        },
        {
          text: "Pass",
          value: "pass",
          name: "pass",
        },
        {
          text: "Service",
          value: "service.name",
          name: "service",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.supplierComps && this.supplierComps.edges
        ? this.supplierComps.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    supplierId(newVal) {
      this.id = newVal;
    },
  },

  methods: {
    onAddCompsClick() {
      console.log("show add comps dialog");
      this.selectedComp = {
        paxFrom: 1,
        paxTo: 10,
        free: 1,
        pass: 0,
        serviceType: "",
      };
      this.showCompDialog = true;
    },
    onSaveSupplierComp(payload) {
      const input = { supplierId: this.id, ...payload };
      const mutation = input.id ? UPDATE_SUPPLIER_COMP : CREATE_SUPPLIER_COMP;
      console.log("save", payload);
      this.$apollo
        .mutate({
          mutation,
          variables: {
            input,
          },
          refetchQueries: [
            {
              query: SUPPLIER_COMPS,
              variables: {
                id: this.id,
              },
            },
          ],
        })
        .then(({ data }) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Supplier Comp Saved",
          });
          this.showCompDialog = false;
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(item) {
      console.log("delete item", item);
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: item.id,
          },
          refetchQueries: [
            {
              query: SUPPLIER_COMPS,
              variables: {
                id: this.id,
              },
            },
          ],
        })
        .then(({ data }) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Supplier Comp Deleted",
          });
          this.showCompDialog = false;
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onEditItem(item) {
      this.selectedComp = { ...item };
      this.showCompDialog = true;
    },
  },

  apollo: {
    supplierComps: {
      query: SUPPLIER_COMPS,
      variables() {
        return { id: this.id };
      },
      skip() {
        return this.id == "";
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/comps/SupplierComps.vue